import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function CollapsibleSection({
  title,
  subtitle = '',
  defaultOpen = false,
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className="ef-collapsible card overflow-hidden">
      <button
        type="button"
        className="ef-collapsible__toggle w-full text-left p-4 flex items-center justify-between gap-3"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <div>
          <h2 className="font-bold text-[var(--d28d-text)] text-sm">{title}</h2>
          {subtitle ? <p className="text-xs d28d-text-muted mt-0.5">{subtitle}</p> : null}
        </div>
        <ChevronDown className={`w-5 h-5 shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open ? <div className="ef-collapsible__body px-4 pb-4 space-y-3 border-t border-[var(--d28d-border)]">{children}</div> : null}
    </section>
  );
}
